import {Action} from '@ngrx/store';

import {Group} from '../../../shared';

export const REQUEST_GROUP_LIST = '[Group] Request Group List';
export const REQUEST_SUCCESS = '[Group] Request Success';
export const REQUEST_FAIL = '[Group] Request Fail';

export const CREATE_GROUP = '[Group] Create Group';
export const CREATE_SUCCESS = '[Group] Create Success';
export const CREATE_FAIL = '[Group] Create Fail';

export const SELECT_GROUP = '[Group] Select Group';
export const DESELECT_GROUP = '[Group] Deselect Group';

// Requests
export class RequestGroupListAction implements Action {
  readonly type = REQUEST_GROUP_LIST;

  // org_token
  constructor(public payload: string) {
  }
}

export class RequestSuccessAction implements Action {
  readonly type = REQUEST_SUCCESS;

  constructor(public payload: Group[]) {
  }
}

export class RequestFailAction implements Action {
  readonly type = REQUEST_FAIL;

  constructor() {
  }
}

// Creates
export class CreateGroupAction implements Action {
  readonly type = CREATE_GROUP;

  constructor(public payload: { orgToken: string, name: string }) {
  }
}

export class CreateSuccessAction implements Action {
  readonly type = CREATE_SUCCESS;

  // Receives organizationToken as of moment
  constructor(public payload: string) {
  }
}

export class CreateFailAction implements Action {
  readonly type = CREATE_FAIL;

  constructor() {
  }
}

// Selects
export class SelectGroupAction implements Action {
  readonly type = SELECT_GROUP;

  // GroupID
  constructor(public payload: string | null) {
  }
}

export class DeselectGroupAction implements Action {
  readonly type = DESELECT_GROUP;

  constructor() {
  }
}


/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
  = RequestGroupListAction
  | RequestSuccessAction
  | RequestFailAction
  | CreateGroupAction
  | CreateSuccessAction
  | CreateFailAction
  | SelectGroupAction
  | DeselectGroupAction;
